// @ts-nocheck
import type * as Types from '@lingoda/monolith-graphql/src/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
import {
    UserSubscriptionContentFragmentDoc,
    UserSubscriptionActionsFragmentDoc,
    UserSubscriptionBaseFragmentDoc,
} from './fragments.monolith.generated';
export type UserSubscriptionsBaseQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserSubscriptionsBaseQuery = {
    readonly __typename?: 'Query';
    readonly subscriptions: {
        readonly __typename?: 'StudentSubscriptionInfo';
        readonly currentSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly status: Types.SubscriptionStatus;
            readonly isInTrial: boolean;
            readonly isRecurring: boolean;
            readonly activatedAt: string | null;
            readonly createdAt: string | null;
            readonly expiresAt: string | null;
            readonly expired: boolean;
            readonly title: string;
            readonly type: Types.SubscriptionType;
            readonly purchaseType: Types.PurchaseType;
            readonly productType: string | null;
            readonly origin: Types.SubscriptionOrigin;
            readonly couponCode: string | null;
            readonly privateCredits: number;
            readonly groupCredits: number;
            readonly lastChargedAt: string | null;
            readonly nextChargeAt: string | null;
            readonly nextEffectiveChargeDate: string | null;
            readonly onPaymentRetrySchedule: boolean;
            readonly nextPaymentRetryAt: string | null;
            readonly pausedAt: string | null;
            readonly resumesAt: string | null;
            readonly startDelayedUntil: string | null;
            readonly externalSubscriptionId: string | null;
            readonly currentFreeTrialDay: number | null;
            readonly productId: number | null;
            readonly price: {
                readonly __typename?: 'Price';
                readonly currency: Types.Currency;
                readonly amount: number;
                readonly amountInMajor: number;
                readonly forHumans: string;
            };
            readonly recurrenceInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
            readonly creditsValidityInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
        } | null;
        readonly nextSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly status: Types.SubscriptionStatus;
            readonly isInTrial: boolean;
            readonly isRecurring: boolean;
            readonly activatedAt: string | null;
            readonly createdAt: string | null;
            readonly expiresAt: string | null;
            readonly expired: boolean;
            readonly title: string;
            readonly type: Types.SubscriptionType;
            readonly purchaseType: Types.PurchaseType;
            readonly productType: string | null;
            readonly origin: Types.SubscriptionOrigin;
            readonly couponCode: string | null;
            readonly privateCredits: number;
            readonly groupCredits: number;
            readonly lastChargedAt: string | null;
            readonly nextChargeAt: string | null;
            readonly nextEffectiveChargeDate: string | null;
            readonly onPaymentRetrySchedule: boolean;
            readonly nextPaymentRetryAt: string | null;
            readonly pausedAt: string | null;
            readonly resumesAt: string | null;
            readonly startDelayedUntil: string | null;
            readonly externalSubscriptionId: string | null;
            readonly currentFreeTrialDay: number | null;
            readonly productId: number | null;
            readonly price: {
                readonly __typename?: 'Price';
                readonly currency: Types.Currency;
                readonly amount: number;
                readonly amountInMajor: number;
                readonly forHumans: string;
            };
            readonly recurrenceInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
            readonly creditsValidityInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
        } | null;
        readonly latestSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly status: Types.SubscriptionStatus;
            readonly isInTrial: boolean;
            readonly isRecurring: boolean;
            readonly activatedAt: string | null;
            readonly createdAt: string | null;
            readonly expiresAt: string | null;
            readonly expired: boolean;
            readonly title: string;
            readonly type: Types.SubscriptionType;
            readonly purchaseType: Types.PurchaseType;
            readonly productType: string | null;
            readonly origin: Types.SubscriptionOrigin;
            readonly couponCode: string | null;
            readonly privateCredits: number;
            readonly groupCredits: number;
            readonly lastChargedAt: string | null;
            readonly nextChargeAt: string | null;
            readonly nextEffectiveChargeDate: string | null;
            readonly onPaymentRetrySchedule: boolean;
            readonly nextPaymentRetryAt: string | null;
            readonly pausedAt: string | null;
            readonly resumesAt: string | null;
            readonly startDelayedUntil: string | null;
            readonly externalSubscriptionId: string | null;
            readonly currentFreeTrialDay: number | null;
            readonly productId: number | null;
            readonly price: {
                readonly __typename?: 'Price';
                readonly currency: Types.Currency;
                readonly amount: number;
                readonly amountInMajor: number;
                readonly forHumans: string;
            };
            readonly recurrenceInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
            readonly creditsValidityInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
        } | null;
    };
};

export type UserSubscriptionActionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserSubscriptionActionsQuery = {
    readonly __typename?: 'Query';
    readonly subscriptions: {
        readonly __typename?: 'StudentSubscriptionInfo';
        readonly currentSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly canChange: boolean;
            readonly canPause: boolean;
            readonly canUnpause: boolean;
            readonly canCancel: boolean;
            readonly canUncancel: boolean;
            readonly canReactivate: boolean;
            readonly canStartNew: boolean;
            readonly canStartNextNow: boolean;
            readonly canCancelTrial: boolean;
            readonly canSkipTrial: boolean;
            readonly subscribeNow: boolean;
            readonly pauseScheduled: boolean;
            readonly paymentNeeded: boolean;
            readonly paymentMethodAdded: boolean | null;
        } | null;
        readonly nextSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly canStartNextNow: boolean;
            readonly canSkipTrial: boolean;
        } | null;
    };
};

export type UserSubscriptionContentQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserSubscriptionContentQuery = {
    readonly __typename?: 'Query';
    readonly subscriptions: {
        readonly __typename?: 'StudentSubscriptionInfo';
        readonly currentSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly contentBlocks: ReadonlyArray<{
                readonly __typename?: 'ContentBlock';
                readonly text: string;
                readonly location: Types.Location;
                readonly label: string | null;
                readonly icon: Types.Icon | null;
                readonly table: string[][] | null;
                readonly isStarred: boolean;
            }>;
        } | null;
        readonly nextSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly contentBlocks: ReadonlyArray<{
                readonly __typename?: 'ContentBlock';
                readonly text: string;
                readonly location: Types.Location;
                readonly label: string | null;
                readonly icon: Types.Icon | null;
                readonly table: string[][] | null;
                readonly isStarred: boolean;
            }>;
        } | null;
    };
};

export type UserSubscriptionsFullQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UserSubscriptionsFullQuery = {
    readonly __typename?: 'Query';
    readonly subscriptions: {
        readonly __typename?: 'StudentSubscriptionInfo';
        readonly currentSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly status: Types.SubscriptionStatus;
            readonly isInTrial: boolean;
            readonly isRecurring: boolean;
            readonly activatedAt: string | null;
            readonly createdAt: string | null;
            readonly expiresAt: string | null;
            readonly expired: boolean;
            readonly title: string;
            readonly type: Types.SubscriptionType;
            readonly purchaseType: Types.PurchaseType;
            readonly productType: string | null;
            readonly origin: Types.SubscriptionOrigin;
            readonly couponCode: string | null;
            readonly privateCredits: number;
            readonly groupCredits: number;
            readonly lastChargedAt: string | null;
            readonly nextChargeAt: string | null;
            readonly nextEffectiveChargeDate: string | null;
            readonly onPaymentRetrySchedule: boolean;
            readonly nextPaymentRetryAt: string | null;
            readonly pausedAt: string | null;
            readonly resumesAt: string | null;
            readonly startDelayedUntil: string | null;
            readonly externalSubscriptionId: string | null;
            readonly currentFreeTrialDay: number | null;
            readonly productId: number | null;
            readonly canChange: boolean;
            readonly canPause: boolean;
            readonly canUnpause: boolean;
            readonly canCancel: boolean;
            readonly canUncancel: boolean;
            readonly canReactivate: boolean;
            readonly canStartNew: boolean;
            readonly canStartNextNow: boolean;
            readonly canCancelTrial: boolean;
            readonly canSkipTrial: boolean;
            readonly subscribeNow: boolean;
            readonly pauseScheduled: boolean;
            readonly paymentNeeded: boolean;
            readonly paymentMethodAdded: boolean | null;
            readonly price: {
                readonly __typename?: 'Price';
                readonly currency: Types.Currency;
                readonly amount: number;
                readonly amountInMajor: number;
                readonly forHumans: string;
            };
            readonly recurrenceInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
            readonly creditsValidityInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
            readonly contentBlocks: ReadonlyArray<{
                readonly __typename?: 'ContentBlock';
                readonly text: string;
                readonly location: Types.Location;
                readonly label: string | null;
                readonly icon: Types.Icon | null;
                readonly table: string[][] | null;
                readonly isStarred: boolean;
            }>;
        } | null;
        readonly nextSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly status: Types.SubscriptionStatus;
            readonly isInTrial: boolean;
            readonly isRecurring: boolean;
            readonly activatedAt: string | null;
            readonly createdAt: string | null;
            readonly expiresAt: string | null;
            readonly expired: boolean;
            readonly title: string;
            readonly type: Types.SubscriptionType;
            readonly purchaseType: Types.PurchaseType;
            readonly productType: string | null;
            readonly origin: Types.SubscriptionOrigin;
            readonly couponCode: string | null;
            readonly privateCredits: number;
            readonly groupCredits: number;
            readonly lastChargedAt: string | null;
            readonly nextChargeAt: string | null;
            readonly nextEffectiveChargeDate: string | null;
            readonly onPaymentRetrySchedule: boolean;
            readonly nextPaymentRetryAt: string | null;
            readonly pausedAt: string | null;
            readonly resumesAt: string | null;
            readonly startDelayedUntil: string | null;
            readonly externalSubscriptionId: string | null;
            readonly currentFreeTrialDay: number | null;
            readonly productId: number | null;
            readonly canChange: boolean;
            readonly canPause: boolean;
            readonly canUnpause: boolean;
            readonly canCancel: boolean;
            readonly canUncancel: boolean;
            readonly canReactivate: boolean;
            readonly canStartNew: boolean;
            readonly canStartNextNow: boolean;
            readonly canCancelTrial: boolean;
            readonly canSkipTrial: boolean;
            readonly subscribeNow: boolean;
            readonly pauseScheduled: boolean;
            readonly paymentNeeded: boolean;
            readonly paymentMethodAdded: boolean | null;
            readonly price: {
                readonly __typename?: 'Price';
                readonly currency: Types.Currency;
                readonly amount: number;
                readonly amountInMajor: number;
                readonly forHumans: string;
            };
            readonly recurrenceInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
            readonly creditsValidityInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
            readonly contentBlocks: ReadonlyArray<{
                readonly __typename?: 'ContentBlock';
                readonly text: string;
                readonly location: Types.Location;
                readonly label: string | null;
                readonly icon: Types.Icon | null;
                readonly table: string[][] | null;
                readonly isStarred: boolean;
            }>;
        } | null;
        readonly latestSubscription: {
            readonly __typename?: 'UserSubscription';
            readonly id: number;
            readonly status: Types.SubscriptionStatus;
            readonly isInTrial: boolean;
            readonly isRecurring: boolean;
            readonly activatedAt: string | null;
            readonly createdAt: string | null;
            readonly expiresAt: string | null;
            readonly expired: boolean;
            readonly title: string;
            readonly type: Types.SubscriptionType;
            readonly purchaseType: Types.PurchaseType;
            readonly productType: string | null;
            readonly origin: Types.SubscriptionOrigin;
            readonly couponCode: string | null;
            readonly privateCredits: number;
            readonly groupCredits: number;
            readonly lastChargedAt: string | null;
            readonly nextChargeAt: string | null;
            readonly nextEffectiveChargeDate: string | null;
            readonly onPaymentRetrySchedule: boolean;
            readonly nextPaymentRetryAt: string | null;
            readonly pausedAt: string | null;
            readonly resumesAt: string | null;
            readonly startDelayedUntil: string | null;
            readonly externalSubscriptionId: string | null;
            readonly currentFreeTrialDay: number | null;
            readonly productId: number | null;
            readonly price: {
                readonly __typename?: 'Price';
                readonly currency: Types.Currency;
                readonly amount: number;
                readonly amountInMajor: number;
                readonly forHumans: string;
            };
            readonly recurrenceInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
            readonly creditsValidityInterval: {
                readonly __typename?: 'DateInterval';
                readonly years: number;
                readonly months: number;
                readonly weeks: number;
                readonly days: number;
                readonly hours: number;
                readonly minutes: number;
                readonly seconds: number;
                readonly microseconds: number;
                readonly forHumans: string;
            } | null;
        } | null;
    };
};

export const UserSubscriptionsBaseDocument = gql`
    query userSubscriptionsBase {
        subscriptions: studentSubscriptionInfo {
            currentSubscription {
                ...UserSubscriptionBase
            }
            nextSubscription {
                ...UserSubscriptionBase
            }
            latestSubscription {
                ...UserSubscriptionBase
            }
        }
    }
    ${UserSubscriptionBaseFragmentDoc}
` as unknown as DocumentNode<UserSubscriptionsBaseQuery, UserSubscriptionsBaseQueryVariables>;
export const UserSubscriptionActionsDocument = gql`
    query userSubscriptionActions {
        subscriptions: studentSubscriptionInfo {
            currentSubscription {
                id
                ...UserSubscriptionActions
            }
            nextSubscription {
                id
                canStartNextNow
                canSkipTrial
            }
        }
    }
    ${UserSubscriptionActionsFragmentDoc}
` as unknown as DocumentNode<UserSubscriptionActionsQuery, UserSubscriptionActionsQueryVariables>;
export const UserSubscriptionContentDocument = gql`
    query userSubscriptionContent {
        subscriptions: studentSubscriptionInfo {
            currentSubscription {
                id
                ...UserSubscriptionContent
            }
            nextSubscription {
                id
                ...UserSubscriptionContent
            }
        }
    }
    ${UserSubscriptionContentFragmentDoc}
` as unknown as DocumentNode<UserSubscriptionContentQuery, UserSubscriptionContentQueryVariables>;
export const UserSubscriptionsFullDocument = gql`
    query userSubscriptionsFull {
        subscriptions: studentSubscriptionInfo {
            currentSubscription {
                id
                ...UserSubscriptionBase
                ...UserSubscriptionActions
                ...UserSubscriptionContent
            }
            nextSubscription {
                id
                ...UserSubscriptionBase
                ...UserSubscriptionActions
                ...UserSubscriptionContent
            }
            latestSubscription {
                id
                ...UserSubscriptionBase
            }
        }
    }
    ${UserSubscriptionBaseFragmentDoc}
    ${UserSubscriptionActionsFragmentDoc}
    ${UserSubscriptionContentFragmentDoc}
` as unknown as DocumentNode<UserSubscriptionsFullQuery, UserSubscriptionsFullQueryVariables>;
